import React from "react";
import { get, map } from "lodash";
import { formatValue } from "utils/number";
import "./InfoTable.scss";

interface InfoTableMeta {
  label?: string;
  key?: string;
  format?: string | ((data: unknown) => unknown);
  [key: string]: unknown;
}

interface InfoTableProps {
  metadata?: InfoTableMeta[];
  data?: Record<string, unknown>;
}

const InfoTable = ({ data, metadata }: InfoTableProps) => {
  return (
    <div className="info-table">
      {map(metadata, (meta, idx) => {
        return (
          <div className="info-table-row" key={idx}>
            <div className="property">{meta.label}:</div>
            <div className="value">
              {
                formatValue(
                  meta,
                  get(data, meta.key as string)
                ) as React.ReactNode
              }
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default InfoTable;
